// core components
import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

// application components
import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { EcomChangepasswordComponent } from './ecom-account/ecom-changepassword/ecom-changepassword.component';
import { EcomForgotPasswordComponent } from './ecom-account/ecom-forgot-password/ecom-forgot-password.component';
import { EcomOlarPointsComponent } from './ecom-account/ecom-olar-points/ecom-olar-points.component';
import { EcomOrdersComponent } from './ecom-account/ecom-orders/ecom-orders.component';
import { PaymentCanDeactivateGaurdService } from './ecom-account/ecom-payment-methods/ecom-payment-can-deactivate-guard.service';
import { EcomPaymentMethodsComponent } from './ecom-account/ecom-payment-methods/ecom-payment-methods.component';
import { EcomProfileEditComponent } from './ecom-account/ecom-profile/ecom-profile-edit/ecom-profile-edit.component';
import { EcomProfileComponent } from './ecom-account/ecom-profile/ecom-profile.component';
import { EcomReferralsComponent } from './ecom-account/ecom-referrals/ecom-referrals.component';
import { EcomHtmlUtils } from './ecom-base-entities/ecom-common/ecom-htmlUtils.services';
import { EcomNetworkUtils } from './ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { EcomHomeComponent } from './ecom-home/ecom-home.component';
import { CheckoutCanDeactivateGaurdService } from './ecom-items/ecom-item-cart-checkout/ecom-checkout-can-deactivate-guard.service';
import { EcomItemCartCheckoutComponent } from './ecom-items/ecom-item-cart-checkout/ecom-item-cart-checkout.component';
import { EcomItemCartComponent } from './ecom-items/ecom-item-cart/ecom-item-cart.component';
import { EcomMessageRedirectComponent } from './ecom-message-redirect/ecom-message-redirect.component';
import { EcomFiltersComponent } from './ecom-navbars/ecom-filters/ecom-filters.component';
import { EcomFooterComponent } from './ecom-navbars/ecom-footer/ecom-footer.component';
import { EcomHeaderComponent } from './ecom-navbars/ecom-header/ecom-header.component';
import { EcomStatusCollectionComponent } from './ecom-order-status/ecom-status-collection/ecom-status-collection.component';
import { EcomStatusDeliveryComponent } from './ecom-order-status/ecom-status-delivery/ecom-status-delivery.component';
import { EcomStatusDineinComponent } from './ecom-order-status/ecom-status-dinein/ecom-status-dinein.component';
import { EComService } from './ecom-services/ecom-common.service';
import { EComWebStorage } from './ecom-services/ecom-webstorage.services';
import { Interceptor } from './ecom-services/interceptor.services';
import { EcomNetworkCheckComponent } from './ecom-shared/ecom-network-check/ecom-network-check.component';
import { LoadingComponentComponent } from './ecom-shared/loading-component/loading-component.component';
import { LoadingService } from './ecom-shared/loading-component/loading-service';
import { EcomStoresComponent } from './ecom-stores/ecom-stores.component';
import { EcomSupportCenterComponent } from './ecom-support-center/ecom-support-center.component';
import { EcomUnauthorizedComponent } from './ecom-unauthorized/ecom-unauthorized.component';

// npm pluggins
import { AgmCoreModule } from '@agm/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { GoogleTagManagerModule, GoogleTagManagerService } from 'angular-google-tag-manager';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { AlertModule } from 'ngx-bootstrap/alert';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { RatingModule } from 'ngx-bootstrap/rating';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxMaskModule } from 'ngx-mask';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ToastrModule } from 'ngx-toastr';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { DrawerComponent } from './drawer/drawer.component';
import { EcomSigninLoyaltyComponent } from './ecom-account/ecom-signin-loyalty/ecom-signin-loyalty.component';
import { EcomSigninNewComponent } from './ecom-account/ecom-signin-new/ecom-signin-new.component';
import { EcomSigninService } from './ecom-account/ecom-signin-new/ecom-signin.service';
import { EcomVouchersComponent } from './ecom-account/ecom-vouchers/ecom-vouchers.component';
import { EcomOlarDataService } from './ecom-data-services/ecom-olar-data-service';
import { GiftCardResultComponent } from './ecom-gift-card-result/ecom-gift-card-result.component';
import { GiftCardComponent } from './ecom-gift-card/ecom-gift-card.component';
import { GiftcardService } from './ecom-gift-card/ecom-giftcard.service';
import { InvalidComponent } from './ecom-invalid-page/ecom-invalid-page.component';
import { EcomPromotionsComponent } from './ecom-items/ecom-item-cart/ecom-promotions/ecom-promotions.component';
import { InAppBrowserService } from './ecom-items/ecom-item-category/InAppBrowserService';
import { ScrollSpyDirective } from './ecom-items/ecom-item-category/scroll-spy.directive';
import { EcomItemDetailsPopupComponent } from './ecom-items/ecom-item-details-popup/ecom-item-details-popup.component';
import { EcomDetailService } from './ecom-items/ecom-item-details2/ecom-item-detail.service';
import { EcomItemDetails2Component } from './ecom-items/ecom-item-details2/ecom-item-details2.component';
import { EcomItemUpsellGridComponent } from './ecom-items/ecom-item-upsell-grid/ecom-item-upsell-grid.component';
import { EcomItemUpsellPopupComponent } from './ecom-items/ecom-item-upsell-popup/ecom-item-upsell-popup.component';
import { EcomItemUpsellComponent } from './ecom-items/ecom-item-upsell/ecom-item-upsell.component';
import { NewEcomItemCategoryV2Component } from './ecom-items/new-ecom-item-category-v2/new-ecom-item-category-v2.component';
import { NewEcomItemCategoryComponent } from './ecom-items/new-ecom-item-category/new-ecom-item-category.component';
import { EcomContactUsComponent } from './ecom-order-status/ecom-contact-us/ecom-contact-us.component';
import { EcomCartService } from './ecom-services/ecom-cart.service';
import { EcomCookies } from './ecom-services/ecom-cookies';
import { EComGoogleAnalytics } from './ecom-services/ecom-google-analytics';
import { EcomSettingService } from './ecom-services/ecom-setting.service';
import { ScrollToTopComponent } from './ecom-shared/ecom-scroll-to-top/ecom-scroll-to-top.component';
import { LanguageComponent } from './ecom-shared/language-dropdown/language-dropdowncomponent';
import { SocialModule } from './ecom-socials/socials.module';
import { ZohoSalesiqComponent } from './ecom-support-center/zoho-salesiq/zoho-salesiq.component';
import { ToastComponent } from './toast/toast.component';
import { ToastService } from './toast/toast.service';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    EcomHomeComponent,
    EcomSigninNewComponent,
    EcomSigninLoyaltyComponent,
    LanguageComponent,
    EcomOrdersComponent,
    EcomChangepasswordComponent,
    EcomProfileComponent,
    EcomHeaderComponent,
    EcomFiltersComponent,
    EcomFooterComponent,
    NewEcomItemCategoryComponent,
    NewEcomItemCategoryV2Component,
    GiftCardComponent,
    GiftCardResultComponent,
    EcomItemCartComponent,
    EcomProfileEditComponent,
    EcomPaymentMethodsComponent,
    EcomStoresComponent,
    EcomStatusDineinComponent,
    EcomStatusCollectionComponent,
    EcomStatusDeliveryComponent,
    LoadingComponentComponent,
    EcomItemCartCheckoutComponent,
    EcomNetworkCheckComponent,
    EcomForgotPasswordComponent,
    ScrollSpyDirective,
    EcomReferralsComponent,
    EcomMessageRedirectComponent,
    EcomUnauthorizedComponent,
    EcomSupportCenterComponent,
    EcomVouchersComponent,
    ZohoSalesiqComponent,
    EcomOlarPointsComponent,
    EcomContactUsComponent,
    EcomPromotionsComponent,
    ScrollToTopComponent,
    EcomItemUpsellComponent,
    EcomItemDetailsPopupComponent,
    EcomItemDetails2Component,
    EcomItemUpsellGridComponent,
    EcomItemUpsellPopupComponent,
    ToastComponent,
    DrawerComponent,
    InvalidComponent
  ],
  imports: [
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    LazyLoadImageModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    HttpClientModule,
    NgxIntlTelInputModule,
    ZXingScannerModule,
    NgxMaterialTimepickerModule,
    RouterModule.forRoot(routes),
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    RatingModule.forRoot(),
    BsDropdownModule.forRoot(),
    NgxWebstorageModule.forRoot(),
    NgxMaskModule.forRoot(),
    ToastrModule.forRoot(),
    AlertModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAznUme5ZpVbeAPPCyO6v-nTMKXBOKKJaU',
      libraries: ['places']
    }),
    PopoverModule.forRoot(),
    CarouselModule.forRoot(),
    BsDatepickerModule.forRoot(),
    InfiniteScrollModule,
    GooglePlaceModule,
    BackButtonDisableModule.forRoot({
      preserveScrollPosition: true
    }),
    GoogleTagManagerModule.forRoot({
      id: 'GTM-W4PPD94',
    }),
    SocialModule
  ],
  providers: [
    { provide: 'googleTagManagerCSPNonce', useValue: 'CSP-NONCE' },
    EcomCookies,
    EComService,
    EcomNetworkUtils,
    EcomHtmlUtils,
    CheckoutCanDeactivateGaurdService,
    PaymentCanDeactivateGaurdService,
    // { provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } },
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true
    },
    LoadingService,
    EComWebStorage,
    EcomOlarDataService,
    GoogleTagManagerService,
    EComGoogleAnalytics,
    EcomCartService,
    ToastService,
    EcomSettingService,
    EcomDetailService,
    EcomSigninService,
    InAppBrowserService,
    GiftcardService,
    DatePipe
  ],
  entryComponents: [
    EcomItemDetailsPopupComponent,
    EcomItemUpsellPopupComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


